import { render, staticRenderFns } from "./AccommodationPlanItem.vue?vue&type=template&id=051ae7ba&scoped=true"
import script from "./AccommodationPlanItem.vue?vue&type=script&lang=ts"
export * from "./AccommodationPlanItem.vue?vue&type=script&lang=ts"
import style0 from "./AccommodationPlanItem.vue?vue&type=style&index=0&id=051ae7ba&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ae7ba",
  null
  
)

export default component.exports